'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseMatches = exports.parseItemMatch = exports.parseHighlight = exports.removeIdFromTitle = exports.MATCH_TYPES = exports.MARK_REGEX_WITHOUT_TAG = exports.MARK_REGEX_WITH_TAG = exports.ID_IN_TITLE = exports.NEW_LINE_REGEXP = undefined;

var _path = require('ramda/src/path');

var _path2 = _interopRequireDefault(_path);

var _map = require('ramda/src/map');

var _map2 = _interopRequireDefault(_map);

var _head = require('ramda/src/head');

var _head2 = _interopRequireDefault(_head);

var _split = require('ramda/src/split');

var _split2 = _interopRequireDefault(_split);

var _reject = require('ramda/src/reject');

var _reject2 = _interopRequireDefault(_reject);

var _contains = require('ramda/src/contains');

var _contains2 = _interopRequireDefault(_contains);

var _isEmpty = require('ramda/src/isEmpty');

var _isEmpty2 = _interopRequireDefault(_isEmpty);

var _replace = require('ramda/src/replace');

var _replace2 = _interopRequireDefault(_replace);

var _trim = require('ramda/src/trim');

var _trim2 = _interopRequireDefault(_trim);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _glamorous = require('glamorous');

var _glamorous2 = _interopRequireDefault(_glamorous);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NEW_LINE_REGEXP = exports.NEW_LINE_REGEXP = /(?:\r\n|\r|\n)/g;
var ID_IN_TITLE = exports.ID_IN_TITLE = /(<mark>)?\(\S*\)(<\/mark>)?$/g;
var MARK_REGEX_WITH_TAG = exports.MARK_REGEX_WITH_TAG = /(<mark>\w*<\/mark>)/g;
var MARK_REGEX_WITHOUT_TAG = exports.MARK_REGEX_WITHOUT_TAG = /<\/*mark>/g;
var MATCH_TYPES = exports.MATCH_TYPES = {
  DATAFLOW: 'dataflow',
  DESCRIPTION: 'description',
  TOPIC: 'topic',
  CODE: 'code',
  DIMENSION: 'dimension'
};

var removeIdFromTitle = exports.removeIdFromTitle = function removeIdFromTitle(title) {
  return (0, _trim2.default)((0, _replace2.default)(ID_IN_TITLE, '', title));
};

var labelIntoReactElement = function labelIntoReactElement(stringToHighlight) {
  if ((0, _isEmpty2.default)(stringToHighlight)) return null;
  if ((0, _contains2.default)('mark>', stringToHighlight)) {
    var noMark = (0, _reject2.default)((0, _isEmpty2.default)(), (0, _split2.default)(MARK_REGEX_WITHOUT_TAG, stringToHighlight));
    return _react2.default.createElement('mark', { key: stringToHighlight + ' __mark' }, (0, _head2.default)(noMark));
  }
  return _react2.default.createElement('span', { key: stringToHighlight + ' __span' }, stringToHighlight);
};

var parseHighlight = exports.parseHighlight = function parseHighlight(stringToHighlight) {
  if ((0, _isEmpty2.default)(stringToHighlight)) return null;
  return (0, _map2.default)(function (elem) {
    return labelIntoReactElement(elem);
  }, (0, _split2.default)(MARK_REGEX_WITH_TAG, stringToHighlight));
};

var parseItemMatch = exports.parseItemMatch = function parseItemMatch(match, dimensionLabel) {
  if ((0, _isEmpty2.default)(match)) {
    return null;
  }
  var matchText = (0, _path2.default)(['match-text'], match);
  var type = (0, _path2.default)(['type'], match);
  var concept = (0, _path2.default)(['concept'], match);
  var displayConcept = concept;
  var displayMatch = (0, _replace2.default)(NEW_LINE_REGEXP, ', ', matchText);
  if (type === MATCH_TYPES.DIMENSION) {
    displayConcept = dimensionLabel;
    displayMatch = concept;
  }

  var displayMatchElement = parseHighlight(displayMatch);
  var displayConceptElement = _react2.default.createElement(_glamorous2.default.div({ fontWeight: 'bold', display: 'inline' }), { key: '' + displayConcept }, displayConcept + ': ');

  if (!(0, _isEmpty2.default)(concept)) {
    return _react2.default.createElement('div', { key: '' + displayMatch }, [displayConceptElement, displayMatchElement]);
  }
  return null;
};

var parseMatches = exports.parseMatches = function parseMatches(matches, dimensionLabel) {
  if (!matches) return [];
  return (0, _map2.default)(function (match) {
    return parseItemMatch(match, dimensionLabel);
  }, matches);
};


//////////////////
// WEBPACK FOOTER
// ./~/oecd-visions/build/components/de-search-dataflow/utils.js
// module id = 2018
// module chunks = 0